export function callUp(phone) {
  const a = document.createElement('a')
  a.href = `tel:${phone}`
  a.click()
}